import React from 'react';
import { connect } from 'react-redux';

export default connect(state => ({ theme: state.App.Theme, sidebar: state.App.Sidebar }))(props => (
    <div className={props.theme.className}>
        <div className={props.sidebar.collapse ? 'wrapper wrapper--full-width' : 'wrapper'}>
            {props.children}
        </div>
    </div>
));



// WEBPACK FOOTER //
// ./src/modules/App/MainWrapper.js